import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { v4 as uuidv4 } from 'uuid'

import PresentationsLanding from './PresentationsLanding'
import PresentationsForm from './PresentationsForm'
import PresentationsBuilding from './PresentationsBuilding'
import PowerpointBuilder from './PowerpointBuilder'
import PresentationsStore from './PresentationsStore'

import './presentations.scss'

@observer
class Presentations extends Component {
    constructor(props) {
        super(props)
        this.presentationsStore = new PresentationsStore(props.store)
        this.props = props
        const params = new URLSearchParams(props.location?.search || '')
        const queryStage = params.get('stage')
        const queryEvent = params.get('event')
        const resolvedStage = props.initialStage || queryStage

        // Pre-select the event Select (e.g. when the report page deep-links
        // with the survey's productId). URL strings get coerced to numbers
        // when the value looks numeric, since eventOptions store productId
        // as a number — strict equality in the Select would otherwise fail.
        if (queryEvent != null && queryEvent !== '') {
            const eventValue = /^\d+$/.test(queryEvent) ? Number(queryEvent) : queryEvent
            this.presentationsStore.setEvent(eventValue)
            this.presentationsStore.handlePresentationsEventFilter({ value: eventValue })
        }

        this.resolvedStage = resolvedStage
        this.loadStarted = false
    }

    componentDidMount() {
        window.addEventListener('keydown', this.handleKeydown)
        if (!this.loadStarted) {
            this.loadStarted = true
            this.kickoffLoad()
        }
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeydown)
        this.presentationsStore.flushPendingSave()
    }

    kickoffLoad = () => {
        const { resolvedStage } = this

        if (resolvedStage === 'builder') {
            this.presentationsStore.startBuilder()
        } else if (resolvedStage === 'building') {
            this.presentationsStore.startBuilding()
        } else if (resolvedStage === 'form') {
            this.presentationsStore.initPresentations()
            this.presentationsStore.showForm()
        } else {
            this.presentationsStore.initPresentations()
        }
    }

    handleStartNew = () => {
        const newId = uuidv4()
        const { event, entrySurvey, entryTitle, entryPrivacy } = this.presentationsStore
        const { history } = this.props
        if (history) {
            history.push(`/presentations/${newId}`, {
                isNew: true,
                event,
                entrySurvey,
                entryTitle,
                entryPrivacy,
            })
        }
    }

    handleKeydown = (e) => {
        if (this.presentationsStore.stage !== 'builder') return

        if (['ArrowUp', 'ArrowDown'].includes(e.key)) {
            e.preventDefault()
        }

        switch (e.key) {
            case 'ArrowUp':
                this.presentationsStore.handleKeyboardListener(-1)
                break
            case 'ArrowDown':
                this.presentationsStore.handleKeyboardListener(1)
                break
            default:
                break
        }
    }

    render() {
        const store = this.presentationsStore

        if (store.stage === 'builder') {
            return <PowerpointBuilder store={store} />
        }

        if (store.stage === 'form') {
            return <PresentationsForm store={store} onStart={this.handleStartNew} />
        }

        if (store.stage === 'building') {
            return <PresentationsBuilding store={store} />
        }

        return <PresentationsLanding store={store} history={this.props.history} />
    }
}

export default Presentations
